import { render, staticRenderFns } from "./OneFamilyAI.vue?vue&type=template&id=72c0be86&"
import script from "./OneFamilyAI.vue?vue&type=script&lang=js&"
export * from "./OneFamilyAI.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports